export const API_ROUTES = {
	STATS: '/stats',
	GROUPS: '/stats/groups',
	CONFIG: '/config',
	PREVIOUS_LEVELS: '/previous-levels',
	TASK_MONTHS: '/tasks/months',
	getGovsWithDoneTaskByMonth: (month) => `/tasks/${month}`,
	getTasksForGovInMonth: (month, gov) => `/tasks/${month}/${gov}`
};
